import { Routes, Route } from 'react-router-dom';
import { Dashboard } from './components/Dashboard';
import { LiveGameViewer } from './components/LiveGameViewer';
import { HistoricalGameViewer } from './components/HistoricalGameViewer';

function Disclaimer() {
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 text-center">
      <p className="text-xs text-amber-700 italic">
        Disclaimer - game information may not reflect the official scorebook and could be inaccurate - we are doing our best!
      </p>
    </div>
  );
}

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Disclaimer />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/live" element={<LiveGameViewer />} />
          <Route path="/live/:gameId" element={<LiveGameViewer />} />
          <Route path="/game/:gameId" element={<HistoricalGameViewer />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
